module.exports = __webpack_public_path__ + "img/file-white.9bdd1e64.svg";